<template>
  <div class="col-md-6">
    <div class="list-group card-item" style="border-radius: 1.2rem">
      <ListGroupItem
        style="padding-top: 0.5rem; padding-bottom: 0.5rem;"
      >
        <div class="flex-1 text-break">
          <div style="font-size: 1rem" v-if="props.data._id" v-touch:hold="onTouchHold">
            {{ props.data.name }}
          </div>

          <div class="text-gray-600" v-if="props.data._id">
            {{ getControllerId(props.data) }}
          </div>

          <div class="form-check" v-else>
            <input
              class="form-check-input"
              type="checkbox"
              :id="`gridCheck${props.index}`"
              :checked="onSelectChecked(props.data)"
              @change="() => onSelectChange(props.data)"
            />
            <label class="form-check-label" :for="`gridCheck${props.index}`">
              {{ getControllerId(props.data) }}
            </label>
          </div>
        </div>
        <div v-if="props.data._id" @click.stop="onDeleteClick">
          <i class="fa-regular fa-trash-can"></i>
        </div>
      </ListGroupItem>

      <ListGroupItem
        class="text-gray-800"
        style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
        v-if="props.data.type == DeviceType.Lamp"
      >
        {{ getInfo(props.data) }}
      </ListGroupItem>

      <!-- <div class="list-group-item d-flex align-items-center text-gray-800">
        {{ props.data }}
      </div> -->
    </div>
  </div>
  <DeviceItemModal
    v-if="deviceItemModal.visible"
    :visible="deviceItemModal.visible"
    :okCallback="onUpdateDeviceName"
    :cancelCallback="deviceItemModal.hide"
    :deviceName="props.data.name"
    :groupId="route.params.groupId"
  />
</template>

<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  watch,
} from 'vue';
import Card from '@/common/template/components/bootstrap/Card.vue';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { DeviceType } from '@/common/constants';
import { formatDisplayLampPorts } from '@/common/utils/controllerDisplayName';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import DeviceItemModal from '@/views/rooms/components/DeviceItemModal.vue';
import useModal from '@/common/hooks/useModal';
import Axios, { DeviceApi } from '@/api';

const { emit } = getCurrentInstance();
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const route = useRoute();
const props = defineProps([
  'index',
  'data',
  'onSelectChecked',
  'onSelectChange',
  'onUpdateDeviceName',
]);
const deviceItemModal = reactive(useModal());
const store = useStore();
const backColor = computed(() => {
  if (props.index % 5 === 0) {
    return 'bg-gradient-custom-orange';
  } else if (props.index % 5 === 1) {
    return 'bg-gradient-custom-pink';
  } else if (props.index % 5 === 2) {
    return 'bg-gradient-custom-teal';
  } else if (props.index % 5 === 3) {
    return 'bg-gradient-custom-indigo';
  } else {
    return 'bg-gradient-custom-blue';
  }
});

const deviceData = ref(props.data);

onMounted(() => {
  console.log('DeviceItem.onMounted().props =>', props);
});

const getInfo = (data) => {
  if (data.isVirtual) {
    return "가상 버튼";
  }
  if (data.type == DeviceType.Lamp) {
    const controllerId = data._id ? data.controllerId : data.serial;
    const ports = data._id ? data.item?.ports : data.data?.port;
    return `연결포트 : ${formatDisplayLampPorts(ports, controllerId)}`;
  }
  else if (data.type == DeviceType.Boiler)
    return `시리얼번호 : ${data._id ? data.item.serial : data.data.serial}`;
  else if (data.type == DeviceType.Curtain || data.type == DeviceType.Dooya || data.type == DeviceType.Rono)
    return `시리얼번호 : ${data._id ? data.item.serial : data.data.serial}`;
  else if (data.type == DeviceType.Ventilator)
    return `시리얼번호 : ${data._id ? data.item.serial : data.data.serial}`;
};

const getControllerId = (data) => {
  return data._id ? data.controllerId : data.serial;
};

const onDeleteClick = () => {
  console.log('DeviceItem.onDeleteClick =>', {
    name: props.data.name,
    deviceId: props.data._id,
  });
  emit('onDeleteClick', { name: props.data.name, deviceId: props.data._id });
};

const onTouchHold = () => {
  deviceItemModal.show();
}

const onUpdateDeviceName = (value) => {
  if (value.length === 0) {
    emitter.emit('showPopAlert', {
      description: '장치 이름을 입력해주세요.',
    });
    return;
  }

  requestUpdateDevice({ name: value }, () => {
    props.onUpdateDeviceName?.(props.data._id)(value);
  });
  deviceItemModal.hide();
};

const requestUpdateDevice = async (params, onSuccess) => {
  try {
    const result = await Axios.patch(
      DeviceApi.UPDATE_DEVICE.replace(':id', props.data._id),
      params,
    );
    if (result.resultCode === '0000') {
      console.log(result.resultData);
      store.commit('home/updateDevice', {
        groupId: route.params.groupId,
        id: props.data._id,
        data: params,
      });
      props.data = {
        ...props.data,
        ...params
      };
      onSuccess?.();
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '장치 정보 수정에 실패했습니다.',
    });
  }
};
</script>

<style scoped>
/* 카드 스타일 개선 */
.list-group.card-item {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.list-group.card-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: #dee2e6;
}

/* 장치 정보 스타일 개선 */
.flex-1.text-break > div:first-child {
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}

.text-gray-600 {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.5;
}

/* 체크박스 스타일 개선 */
.form-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-check-input {
  margin-top: 0;
  cursor: pointer;
  width: 1.1rem;
  height: 1.1rem;
  border: 2px solid #ced4da;
  transition: all 0.2s ease;
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.form-check-label {
  cursor: pointer;
  font-size: 0.875rem;
  color: #495057;
  line-height: 1.5;
  margin-bottom: 0;
}

/* 삭제 버튼 스타일 개선 */
.flex-1.text-break + div {
  cursor: pointer;
  color: #dc3545;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}

.flex-1.text-break + div:hover {
  background-color: #f8d7da;
  color: #721c24;
  transform: scale(1.1);
}

.flex-1.text-break + div i {
  font-size: 0.9rem;
}

/* 장치 정보 (포트 등) 스타일 */
.text-gray-800 {
  font-size: 0.85rem;
  color: #495057;
  line-height: 1.5;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

/* ListGroupItem 패딩 조정 */
.list-group-item {
  border: none;
  padding-left: 1rem;
  padding-right: 1rem;
}

/* 타이포그래피 미세 조정 */
.col-md-6 {
  letter-spacing: -0.01em;
}

.flex-1.text-break {
  line-height: 1.5;
}
</style>
